import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { SET_NEWS_LIST_CONTENT, SET_NEWS_LIST_LOADING } from '../actions/newsListActionCreator';
import { TAction } from '../actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

const DEFAULT_STATE = {
  isLoading: false,
  isLoaded: false
};

export default function newsList(
  state: Partial<TCharacterDetailsClientState> = DEFAULT_STATE,
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case SET_NEWS_LIST_LOADING: {
      const newState: any = {
        ...state,
        isLoading: action.payload.loading,
        isLoaded: !action.payload.loading
      };
      return newState;
    }
    case SET_NEWS_LIST_CONTENT: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isLoaded: true
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default: {
      return state;
    }
  }
}
